// Define regular expressions for mobile and tablet detection
const IS_MOBILE_REGEX: RegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const IS_TABLET_REGEX: RegExp = /(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i;

// Function to check if the device is mobile or tablet
export const checkIsMobileOrTablet = (): boolean => {
  const userAgent = window.navigator.userAgent;
  const isMobile = IS_MOBILE_REGEX.test(userAgent);
  const isTablet = IS_TABLET_REGEX.test(userAgent);
  return isMobile || isTablet;
};
// Function to check if the device is a desktop
export const isScreenWidthAtLeast = (deviceWith: number): boolean => window.screen.width >= deviceWith;
// Function to check if the device is android
export const checkIsAndroid = (): boolean => {
  const userAgent = window.navigator.userAgent;
  return /android/i.test(userAgent);
};
